import { clearCachedAccessStatus } from "./accessStatusCache";

const ACCESS_SESSION_KEY = "dople_access_token";
const ACCESS_STORAGE_KEY = "dople_access_token";
const DASHBOARD_SESSION_REFRESH_KEY = "dople_dashboard_session_refresh_started_v1";
const RUNTIME_LOCATION_SYNC_KEY = "dople_runtime_location_sync_v1";
const RUNTIME_LOCATION_CURRENT_KEY = "dople_runtime_location_current_v1";

let memoryAccessToken = (() => {
  try {
    return sessionStorage.getItem(ACCESS_SESSION_KEY);
  } catch (error) {
    return null;
  }
})();

export function getAccessToken() {
  return memoryAccessToken;
}

export function getRefreshToken() {
  return null;
}

export function storeAuthTokens(payload = {}) {
  const access = payload?.access || null;

  if (access) {
    memoryAccessToken = access;
    try {
      sessionStorage.setItem(ACCESS_SESSION_KEY, access);
    } catch (error) {
      // In-memory auth still works if sessionStorage is unavailable.
    }
  } else {
    memoryAccessToken = null;
    try {
      sessionStorage.removeItem(ACCESS_SESSION_KEY);
      localStorage.removeItem(ACCESS_STORAGE_KEY);
    } catch (error) {
      // ignore storage failures
    }
  }

  localStorage.removeItem("access_token");
  if ("access" !== ACCESS_STORAGE_KEY) {
    localStorage.removeItem("access");
  }
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("refresh");
}

export function clearAuthTokens() {
  clearCachedAccessStatus();
  memoryAccessToken = null;
  try {
    sessionStorage.removeItem(ACCESS_SESSION_KEY);
    sessionStorage.removeItem(DASHBOARD_SESSION_REFRESH_KEY);
    sessionStorage.removeItem(RUNTIME_LOCATION_SYNC_KEY);
    sessionStorage.removeItem(RUNTIME_LOCATION_CURRENT_KEY);
  } catch (error) {
    // ignore storage failures
  }
  localStorage.removeItem(ACCESS_STORAGE_KEY);
  localStorage.removeItem("dople_onboarding_completion");
  localStorage.removeItem("access_token");
  if ("access" !== ACCESS_STORAGE_KEY) {
    localStorage.removeItem("access");
  }
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("refresh");
  // Legacy keys that older builds may have left behind.
  localStorage.removeItem("dople_access_token");
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("refresh_token");
}

export function buildAuthHeaders(headers = {}) {
  const token = getAccessToken();
  const existingHeader = headers.Authorization || headers.authorization;

  if (!token || existingHeader) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
}

function decodeBase64Url(value) {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (normalized.length % 4)) % 4);
  return atob(normalized + padding);
}

export function parseJwt(token) {
  if (!token) return null;

  try {
    const [, payload] = token.split(".");
    if (!payload) return null;
    return JSON.parse(decodeBase64Url(payload));
  } catch (error) {
    return null;
  }
}

export function getTokenExpiryMs(token) {
  const payload = parseJwt(token);
  const exp = payload?.exp;
  return typeof exp === "number" ? exp * 1000 : null;
}

export function isTokenExpired(token, skewSeconds = 30) {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) return true;
  return expiryMs <= Date.now() + skewSeconds * 1000;
}
